import { createAuthRequestInit } from '../utils/auth';
import { API_BASE } from '../config/api';

export interface SubscriptionSettings {
  defaultBillingCycle: 'monthly' | 'annual' | 'yearly' | string;
  gracePeriodDays: number;
  autoRenewalDefault: 'enabled' | 'disabled' | string;
  paymentGateway: string;
}

export async function getSubscriptionSettings(): Promise<SubscriptionSettings> {
  const res = await fetch(`${API_BASE}/settings/subscriptions`, createAuthRequestInit());
  if (!res.ok) {
    throw new Error(`Failed to load settings (Status: ${res.status})`);
  }
  const json = await res.json();
  return json.data as SubscriptionSettings;
}

export async function updateSubscriptionSettings(settings: SubscriptionSettings): Promise<SubscriptionSettings> {
  const res = await fetch(
    `${API_BASE}/settings/subscriptions`,
    createAuthRequestInit(
      {
        method: 'PUT',
        body: JSON.stringify(settings)
      },
      true
    )
  );
  if (!res.ok) {
    let msg = 'Failed to update settings';
    try { const j = await res.json(); msg = j?.message || msg; } catch {}
    throw new Error(`${msg} (Status: ${res.status})`);
  }
  const json = await res.json();
  return json.data as SubscriptionSettings;
}


